import z from 'zod';

export const MaterialSchema = z.object({
  userId: z.string().min(1),
  filePath: z.string().min(1),
  s3key: z.string().min(1),
  fieldPath: z.union([z.string().min(1), z.undefined()]),
  fileName: z.string().min(1),
  contentType: z.union([z.literal('application/pdf'), z.string().regex(/image\/*/)]),
  description: z.union([z.string().min(1), z.undefined()]),
  user: z.string().min(1),
  time: z.number().int(),
  size: z.number().int()
});